<template>
    <div>

        <config-main-title>
            Dashboards
        </config-main-title>

        <div v-if="!em_edicao">

            <div class="form-row mb-3">
                <div class="col col-12 col-md-6 d-flex flex-column">
                    <az-input icon="fas fa-search" v-model="search" />
                </div>
                <div class="col col-12 col-md-3 d-flex flex-column">
                    <div class="btn-group mb-1" role="group" aria-label="Basic example">
                        <button type="button" class="btn" :class="viewMode == 'A' ? 'btn-secondary' : 'btn-outline-secondary'" 
                        @click="viewMode = 'A'">
                            Ativos
                        </button>
                        <button type="button" class="btn" :class="viewMode == 'T' ? 'btn-secondary' : 'btn-outline-secondary'" 
                        @click="viewMode = 'T'">
                            Todos
                        </button>
                    </div>
                </div>
                <div class="col col-12 col-md-3 d-flex flex-column">
                    <router-link :to="{ path: '/dashboard/editor' }" class="btn btn-outline-success" type="button">
                        Incluir Dashboard
                    </router-link>
                </div>
            </div>

        </div>

        <div v-if="( !lista || !lista.length )">
            <az-empty-state 
                :msg="'Nenhuma Dashboard identificado.'" 
                icon="fa-solid fa-gauge-high" />
		</div>

        <div v-if="!em_edicao && lista && lista.length">

            <div class="list-group mb-3 az-anime-surgir mb-3">
                <li class="list-group-item d-flex justify-content-between" v-for="(dado, id) in lista" :key="id">
                    <span>
                        <a href="#" @click.prevent="editar(dado)" class="h5 card-link mb-0 mr-3" v-if="dado.custom">
                            {{ dado.title }}
                        </a>
                        <span v-else class="h5 card-link mb-0 mr-3">
                            {{ dado.title }}
                        </span>
                    </span>
                    <span>
                        <template v-if="viewMode == 'T'">
                            <div class="custom-control custom-switch" v-if="dado.custom">
                                <input type="checkbox" class="custom-control-input" 
                                    :id="'ativo-' + id" 
                                    v-model="dado.active" 
                                    @change="toggle(dado)">
                                <label class="custom-control-label" :for="'ativo-' + id"></label>
                            </div>
                        </template>

                        <div v-else>
                            <a href="#" @click.prevent="abrir(dado)">
                                <i class="fa-solid fa-gauge-high"></i>
                            </a>
                        </div>
                    </span>
                </li>
            </div>

        </div>
    </div>
</template>

<script>
import $ from 'jquery';
import ConfigMainTitle from '../cadastros/shared/ConfigMainTitle.vue';
import AzInput from '../shared/forms/AzInput.vue';
import AzEmptyState from '../util/AzEmptyState.vue';

export default {
    data () { 
        return { 
            dados: null, 
            em_edicao: false, 
            item: null, 
            validate: false,
            search: "", 
            viewMode: "A",
            title: "", 
            short_title: "", 
            service: "",
        }
    },

    props: ['cadastro'],

    components: { 
        ConfigMainTitle,
        AzInput,
        AzEmptyState,
    },

    computed: { 
        lista_filtros: function () { 

            if ( !this.item ) 
                return [];

            return this.item.filtros.filter(item => !item.excluido);

        },

        lista: function () { 
            let pesquisar = this.search.trim();
            let parts = pesquisar.replace(' ','.*');
            let match = parts;
            let reg = new RegExp(match, 'i');

            return this.dados && this.dados.length ? 
                this.dados.filter (item => { 
                    return ( this.viewMode == 'T' || item.active ) && 
                        ( !this.search || reg.test(JSON.stringify(item)) );
                }) : null;
        },

    },

    methods: { 
        
        load () { 
            this.$util.load(this, { 
                service:'dashboards',
                func: 'lista',
                parms: { 
                    cadastro: true, 
                },
            });
        },

        abrir (item) { 
            this.$router.push({ path: "/dashboard/" + item.id });          
        },

        editar (item) { 
            this.$router.push({ path: "/dashboard/editor/" + item.id });
        },

        toggle (item) { 

            this.$util.atualizar(this, { 
                service: 'dashboards',
                func:'toggle',
                dados: item,
            });

        },
    },

    mounted () { 
        this.load ();

        this.$store.commit('setBreadcrumb', 
			[
				{ name: "Relatórios", path: "/relatorios"},
                { name: "Dashboards", path: "/dashboards"}
			]
        );
    },

    updated () { 
        $('[data-toggle="tooltip"]').tooltip();
    }


}
</script>